<template>
  <div>
    <BlocoFormularioCadastro voltar="/evolucao/formulario" @salvar="salvar()">
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <h4>Formulário</h4>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                    <CampoNome
                      :label-sup="'(1)'"
                      :validacao="v$.formulario.nome"
                      :valor="formulario.nome"
                      @atualizar="formulario.nome = $event"
                    >
                      <template #mensagensValidacao>
                        <span
                          v-if="!v$.formulario.nome.required"
                          class="help-block"
                        >
                          Campo é obrigatório.
                        </span>
                        <span
                          v-if="!v$.formulario.nome.minLength"
                          class="help-block"
                        >
                          Campo deve ter pelo menos
                          {{ v$.formulario.nome.$params.minLength.min }}
                          letras.
                        </span>
                        <span
                          v-if="!v$.formulario.nome.maxLength"
                          class="help-block"
                        >
                          Campo deve ter no máximo
                          {{ v$.formulario.nome.$params.maxLength.max }}
                          letras.
                        </span>
                      </template>
                    </CampoNome>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                    <SelecionarEspecialidade
                      :label-sup="'(1)'"
                      :mostrar-selecione="true"
                      :mostrar-todos="false"
                      :valor="formulario.especialidade.nome"
                      :validacao="v$.formulario.especialidade._id"
                      :remover="['Avaliação']"
                      @atualizar="aoAtualizarEspecialidade"
                      @pronto="especialidades = $event"
                    />
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                    <SelecionarSituacao
                      :label-sup="'(1)'"
                      :validacao="v$.formulario.ativo"
                      :valor="formulario.ativo"
                      :mostrar-todos="false"
                      @atualizar="formulario.ativo = $event"
                    >
                      <template #mensagensValidacao>
                        <span
                          v-if="!v$.formulario.ativo.required"
                          class="help-block"
                        >
                          Campo é obrigatório.
                        </span>
                      </template>
                    </SelecionarSituacao>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                    <div class="checkbox">
                      <label>
                        <input
                          id="formularioDeAvaliacao"
                          v-model="formulario.avaliacao"
                          type="checkbox"
                          name="formularioDeAvaliacao"
                        />
                        Avaliação
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <h4>Questões disponíveis</h4>
                  </div>
                  <div
                    v-if="questoesSelecionadas.length"
                    class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
                  >
                    <transition name="fade">
                      <div class="pull-right">
                        <div class="btn-group pull-right" role="group">
                          <div class="btn-group btn-group-sm" role="group">
                            <button
                              v-if="questoesSelecionadas.length > 1"
                              type="button"
                              class="btn btn-success"
                              @click="adicionarQuestoesComposta()"
                            >
                              <span class="fa fa-compress" />
                              Criar composição
                            </button>
                          </div>
                          <div class="btn-group btn-group-sm" role="group">
                            <button
                              v-if="questoesSelecionadas.length"
                              type="button"
                              class="btn btn-success"
                              @click="adicionarQuestoes()"
                            >
                              <span class="fa fa-plus" />
                              Adicionar
                              {{ questoesSelecionadas.length }} selecionados
                            </button>
                          </div>
                          <div class="btn-group btn-group-sm" role="group">
                            <button
                              type="button"
                              class="btn btn-danger"
                              @click="removerQuestoes()"
                            >
                              <span class="fa fa-trash" />
                              Limpar
                            </button>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <input
                      id="questoesFiltro"
                      class="form-control"
                      type="text"
                      placeholder="Buscar questões"
                      @input="recuperarQuestoesAtivas($event.target.value)"
                    />
                  </div>
                </div>
                <br />
                <div class="row">
                  <transition name="fade">
                    <div
                      v-if="questoes.length"
                      style="max-height: 200px; overflow: auto"
                      class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                    >
                      <table
                        class="table table-striped table-bordered table-hover"
                      >
                        <thead>
                          <tr>
                            <th style="width: 16px">
                              <input
                                type="checkbox"
                                @click="todasQuestoesToggle($event)"
                              />
                            </th>
                            <th>Questão</th>
                            <th>Tipo</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(questao, index) in questoes"
                            :key="`${questao._id}_${index}`"
                            @click.stop="questaoToggle($event, questao)"
                          >
                            <td>
                              <input
                                :id="'questaoDispCheckbox' + index"
                                :ref="'questaoRef_' + questao._id"
                                style="margin-right: 8px"
                                type="checkbox"
                                @click.stop.prevent="
                                  questaoToggle($event, questao)
                                "
                              />
                            </td>
                            <td :id="'questaoDispEnunciado' + index">{{
                              questao.enunciado
                            }}</td>
                            <td :id="'questaoDispTipo' + index">{{
                              questao.tipo
                            }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="well" style="margin: 0.8rem 1.5rem">
                      <p> Não existem questões disponíveis. </p>
                      <br />
                      <RouterLink
                        :to="'/evolucao/questao/cadastro'"
                        role="button"
                        class="btn btn-primary"
                        ><span class="fa fa-clipboard" /> Cadastrar
                        questoes</RouterLink
                      >
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <h4>Questões</h4>
                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <transition name="fade">
                      <div class="pull-right">
                        <div class="btn-group pull-right" role="group">
                          <div class="btn-group btn-group-sm" role="group">
                            <button
                              type="button"
                              class="btn btn-success"
                              @click="
                                formulario.gruposQuestoes.push({
                                  titulo: '',
                                  questoes: [],
                                })
                              "
                            >
                              <span class="fa fa-plus" />
                              Adicionar grupo
                            </button>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div
                      v-if="formulario.gruposQuestoes.length === 0"
                      class="well"
                    >
                      Nenhuma questão selecionada para o questionário.
                    </div>
                    <div v-else>
                      <transition name="fade">
                        <div
                          v-if="formulario.gruposQuestoes.length"
                          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 questoes-selecionadas"
                        >
                          <div
                            v-for="(
                              grupoQuestao, j
                            ) in formulario.gruposQuestoes"
                            :key="`${grupoQuestao._id}_${j}`"
                            class="questao-selecionada"
                          >
                            <div class="questao-selecionada-titulo">
                              <input
                                v-model="grupoQuestao.titulo"
                                placeholder="Título do grupo"
                                type="text"
                                class="questao-selecionada-input form-control"
                              />
                              <div class="grupo-questao-acoes">
                                <button
                                  v-if="j !== 0"
                                  type="button"
                                  class="btn btn-sm"
                                  @click="moverGrupo(grupoQuestao, j, 1)"
                                >
                                  <span class="fa fa-chevron-up" />
                                  Mover para cima
                                </button>
                                <button
                                  v-if="
                                    j !== formulario.gruposQuestoes.length - 1
                                  "
                                  type="button"
                                  class="btn btn-sm"
                                  @click="moverGrupo(grupoQuestao, j, -1)"
                                >
                                  <span class="fa fa-chevron-down" />
                                  Mover para baixo
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-sm btn-danger"
                                  @click="
                                    removerQuestaoFormulario(grupoQuestao)
                                  "
                                >
                                  <span class="fa fa-trash" />
                                  Excluir
                                </button>
                              </div>
                            </div>
                            <div v-if="grupoQuestao" class="questao-combo">
                              <div
                                v-for="(questao, k) in grupoQuestao.questoes"
                                :key="`${questao._id}_${k}`"
                                class="questao-item"
                                :class="{
                                  'questao-item-linha': questao.expandida,
                                }"
                              >
                                <div class="questao-enunciado">
                                  {{ questao.enunciado }}
                                </div>
                                <div>
                                  <span class="questao-tipo">
                                    {{ questao.tipo }}
                                  </span>
                                </div>
                                <div class="btn-questao-comp-acoes">
                                  <button
                                    v-if="k > 0"
                                    type="button"
                                    class="btn btn-xs btn-default"
                                    title="Mover para a esquerda"
                                    @click="
                                      swapItems(grupoQuestao.questoes, k, k - 1)
                                    "
                                  >
                                    <span class="fa fa-chevron-left" />
                                  </button>
                                  <button
                                    v-if="k < grupoQuestao.questoes.length - 1"
                                    type="button"
                                    class="btn btn-xs btn-default"
                                    title="Mover para a direita"
                                    @click="
                                      swapItems(grupoQuestao.questoes, k, k + 1)
                                    "
                                  >
                                    <span class="fa fa-chevron-right" />
                                  </button>
                                  <button
                                    v-if="
                                      grupoQuestao.questoes.length > 1 &&
                                      !questao.expandida
                                    "
                                    type="button"
                                    class="btn btn-xs btn-default"
                                    title="Usar linha inteira"
                                    @click="$set(questao, 'expandida', true)"
                                  >
                                    <span class="fa fa-expand" />
                                  </button>
                                  <button
                                    v-if="questao.expandida"
                                    type="button"
                                    class="btn btn-xs btn-default"
                                    title="Remover linha cheia"
                                    @click="$set(questao, 'expandida', false)"
                                  >
                                    <span class="fa fa-compress" />
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-xs btn-default"
                                    title="Remover"
                                    @click="
                                      removerQuestaoComposta(grupoQuestao, j)
                                    "
                                  >
                                    <span class="fa fa-times" />
                                  </button>
                                </div>
                              </div>
                              <div class="questao-item-placeholder">
                                <Popover>
                                  <button
                                    :id="`btn-add-${j}`"
                                    type="button"
                                    class="btn btn-link"
                                  >
                                    <span class="fa fa-plus" />
                                    Adicionar <span class="caret"></span>
                                  </button>
                                  <template #popover>
                                    <div>
                                      <input
                                        v-model="questaoAdicionarFiltro"
                                        data-test-id="input-questaoadicionarfiltro"
                                        type="text"
                                        placeholder="Pesquisar..."
                                        class="form-control input-sm"
                                      />
                                      <div
                                        class="questoes-adicionar-grupo-lista"
                                      >
                                        <div
                                          v-for="questao in questoes.filter(
                                            (q) =>
                                              q.enunciado.includes(
                                                questaoAdicionarFiltro
                                              )
                                          )"
                                          :key="questao._id"
                                          class="questoes-adicionar-grupo-lista-item"
                                          @click="
                                            grupoQuestao.questoes.push(questao)
                                          "
                                        >
                                          <span class="text-primary">
                                            {{ questao.enunciado }}
                                          </span>
                                          {{ questao.tipo }}
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </Popover>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </BlocoFormularioCadastro>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { maxLength, minLength, required } from '@vuelidate/validators'
import { isEqual } from 'lodash'

import Popover from '@/componentes/ui/popover/Popover.vue'
import { useMenu } from '@/composables/useMenu'
import { cadastroMixin } from '@/mixins/CadastroMixin'
import EspecialidadeServico from '@/servicos/EspecialidadeServico'
import FormularioServico from '@/servicos/FormularioServico'
import QuestaoServico from '@/servicos/QuestaoServico'

const especialidadeServico = new EspecialidadeServico()
const questaoServico = new QuestaoServico()

export default {
  components: { Popover },
  mixins: [cadastroMixin],
  async beforeRouteLeave(to, from, next) {
    if (!this.formulario._id) return next()

    try {
      const response = await this.servico.recuperar(this.formulario._id)
      const formularioAntigo = response.formulario

      if (
        isEqual(formularioAntigo.nome, this.formulario.nome) &&
        isEqual(
          formularioAntigo.especialidade,
          this.formulario.especialidade
        ) &&
        isEqual(
          formularioAntigo.gruposQuestoes,
          this.formulario.gruposQuestoes
        ) &&
        isEqual(formularioAntigo.avaliacao, this.formulario.avaliacao)
      ) {
        next()
      } else {
        if (
          confirm(
            'Alterações foram realizadas, você tem certeza que deseja sair?'
          )
        ) {
          next()
        } else {
          next(false)
        }
      }
    } catch (error) {
      next(false)
    }
  },
  setup() {
    useMenu(51)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      entidade: 'formulario',
      consulta: 'Formulario',
      servico: new FormularioServico(),
      especialidades: [],
      questoes: [],
      questoesSelecionadas: [],
      questaoAdicionarFiltro: '',
      formulario: {
        nome: '',
        especialidade: { _id: null },
        gruposQuestoes: [],
        ativo: 'true',
        avaliacao: false,
      },
    }
  },
  validations: {
    formulario: {
      nome: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(200),
      },
      especialidade: { _id: { required } },
      ativo: { required },
    },
  },
  async created() {
    const { especialidades } = await especialidadeServico.recuperarTodos({
      ativo: true,
    })
    this.especialidades = especialidades
    this.recuperarFormulario()
  },
  methods: {
    async recuperarFormulario() {
      const id = this.$route.params.id

      if (id) {
        await this.servico.recuperar(id)
      }

      await this.recuperarQuestoesAtivas()
    },
    swapItems(arr, idx1, idx2) {
      const aux = arr[idx2]
      this.$set(arr, idx2, arr[idx1])
      this.$set(arr, idx1, aux)
    },
    removerQuestaoComposta(composicao, index) {
      composicao.questoes.splice(index, 1)
    },
    adicionarQuestoesComposta() {
      this.formulario.gruposQuestoes.push({
        questoes: this.questoesSelecionadas,
      })
      this.removerQuestoes()
    },
    adicionarQuestoes() {
      this.questoesSelecionadas.forEach((q) => {
        this.formulario.gruposQuestoes.push({
          questoes: [q],
        })
      })

      this.removerQuestoes()
    },
    removerQuestaoFormulario(questao) {
      const index = this.formulario.gruposQuestoes.indexOf(questao)
      if (~index) this.formulario.gruposQuestoes.splice(index, 1)
    },
    moverGrupo(grupoQuestao, index, movimento) {
      const swap = this.formulario.gruposQuestoes[index - movimento]
      this.$set(this.formulario.gruposQuestoes, index - movimento, grupoQuestao)
      this.$set(this.formulario.gruposQuestoes, index, swap)
    },
    removerQuestoes() {
      this.questoesSelecionadas = []
      this.questoes = []
      this.recuperarQuestoesAtivas()
    },
    todasQuestoesToggle(evento) {
      const checked = evento.target.checked

      this.questoes.forEach((q) => {
        this.$refs['questaoRef_' + q._id][0].checked = checked
      })

      if (checked) {
        this.questoesSelecionadas.push(...this.questoes)
      } else {
        this.questoesSelecionadas = []
      }
    },
    questaoToggle(evento, questao) {
      const index = this.questoesSelecionadas.findIndex(
        (q) => q._id === questao._id
      )

      if (~index) {
        this.questoesSelecionadas.splice(index, 1)
      } else {
        this.questoesSelecionadas.push(questao)
      }

      setTimeout(() => {
        this.$refs['questaoRef_' + questao._id][0].checked = !~index
      }, 0)
    },
    async recuperarQuestoesAtivas(enunciado) {
      const resp = await questaoServico.recuperarTodos({
        enunciado,
        ativo: true,
        skip: 0,
        limit: 900,
      })
      this.questoes = resp.questoes
    },
    processarEntidade(res) {
      this.formulario.ativo = res.formulario.ativo ? 'true' : 'false'
    },
    aoAtualizarEspecialidade(nome) {
      if (!this.especialidades || !this.especialidades.length) return
      this.formulario.especialidade = this.especialidades
        .map((e) => ({ _id: e._id, nome: e.nome }))
        .find((e) => e.nome === nome)
    },
  },
}
</script>

<style scoped>
.table-hover tbody tr:hover {
  cursor: pointer;
}

.questoes-selecionadas .questao-selecionada {
  display: flex;
  flex-flow: column;
  padding: 0.4rem 1rem;
  border: 1px solid #ecf0f1;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.questao-selecionada-titulo {
  display: flex;
  align-items: center;
  padding: 0.4rem 1rem;
}

.questao-selecionada-input {
  border: none;
  border-bottom: 1px solid #ecf0f1;
  margin-right: 16px;
  padding: 1px;
}

.questao-selecionada-input:focus,
.questao-selecionada-input:focus-within {
  border-bottom: 1px solid #18bc9c;
}

.questao-combo {
  display: flex;
  flex-flow: row wrap;
}

.questao-item {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  width: 180px;
  padding: 0.6rem 1.2rem 1rem 1.2rem;
  margin: 0.6rem 0.4rem;
  background-color: white;
  border: 1px solid #ecf0f1;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.questao-item-placeholder {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 180px;
  padding: 0.6rem 1.2rem 1rem 1.2rem;
  margin: 0.6rem 0.4rem;
  background-color: white;
  border: 2px dashed #18bc9c;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.questao-item-linha {
  flex-basis: 100%;
}

.questao-enunciado {
  margin-bottom: 1.2rem;
  font-size: 1.4rem;
}

.questao-tipo {
  padding: 0.4rem 0.6rem;
  font-size: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  background-color: #ddd;
  border-radius: 4px;
}

.btn-questao-comp-acoes {
  position: absolute;
  top: 0;
  right: 0;
  display: none;
  color: #666;
}

.questao-item:hover .btn-questao-comp-acoes {
  display: block;
}

.questoes-adicionar-grupo-lista {
  max-height: 400px;
  display: flex;
  flex-flow: column;
  overflow: auto;
}

.questoes-adicionar-grupo-lista-item {
  padding: 8px;
  cursor: pointer;
  display: flex;
  flex-flow: column;
  color: black;
}

.questoes-adicionar-grupo-lista-item:hover {
  background-color: #ecf0f1;
}

.grupo-questao-acoes {
  display: flex;
}
</style>
